import { Component, Input, OnChanges } from '@angular/core';
import { LiquidacionService } from 'src/app/services/liquidacion/liquidacion.service';
import { guardarArchivo } from 'src/app/utils/descargar';

/**
 * DETALLE DE UNA LIQUIDACIÓN DE COBRANZA (6.5). Lo abre el tesorero en el cierre y quien firma en Por aprobar: la cuenta
 * de lo aplicado a lo que se paga, los cinco controles (reemplazan «cuadra con los pagarés»), las ventas del día de mayor
 * monto y el Excel de auditoría con todo (Resumen, Ventas, Abonos, Retenidos, Reversos y Controles).
 */
@Component({
  selector: 'app-liquidacion-cobranza',
  templateUrl: './liquidacion-cobranza.component.html'
})
export class LiquidacionCobranzaComponent implements OnChanges {
  @Input() dia = '';
  @Input() comercio = '';

  cargando = false;
  error = '';
  d: any = null;

  constructor(private liq: LiquidacionService) { }

  ngOnChanges(): void { this.cargar(); }

  cargar = async (): Promise<void> => {
    if (!this.dia || !this.comercio) return;
    this.cargando = true; this.error = '';
    try { this.d = await this.liq.cobranzaDetalle(this.dia, this.comercio); }
    catch (e: any) { this.error = e?.error?.msg || 'No se pudo leer el detalle de la cobranza.'; }
    finally { this.cargando = false; }
  };

  /** Las filas de un mismo pago van juntas: el pago se muestra solo en la primera de cada grupo (COB-18). */
  primeraDelPago(filas: any[], i: number): boolean {
    if (i === 0) return true;
    const a = filas[i], b = filas[i - 1];
    if (!a.pago_referencia) return true;
    return a.pago_referencia !== b.pago_referencia || a.pago_banco !== b.pago_banco || a.pago_monto !== b.pago_monto;
  }

  descargar = async (): Promise<void> => {
    try { guardarArchivo(await this.liq.cobranzaExcel(this.dia, this.comercio), `cobranza-${this.comercio}-${this.dia}.xlsx`); }
    catch (e: any) { this.error = 'No se pudo descargar el Excel de cobranza.'; }
  };
}
